import React ,{useState} from 'react'
import "./style.css"
import Navbar from '../../components/navbar/Navbar';
  

const Login = () => {
  const [email ,setEmail] =useState('');
  const [password, setPassword] =useState('');
  const [allEntry, setAllEntry] = useState([ ]);
 

  const handleSubmit =(e)=>{
      e.preventDefault();
      const newEntry={email: email, password:password};
      setAllEntry([...allEntry,newEntry]);
      alert('You are logged In')
      
  }

  return (
    <div>
    <Navbar/>
    
    <div className='formContainer'>
    <form className='loginRegFrom' onSubmit={handleSubmit}>
      <label className='' htmlFor='email' >Email</label>
      <input type='email' value={email} onChange ={(e)=>setEmail(e.target.value)} placeholder='Enter your email' name='email' autoComplete='off'/>
    <label htmlFor='password' >Password</label>
    <input type='password' value={password} onChange ={(e)=>setPassword(e.target.value)} placeholder='Enter your password' name='password' autoComplete='off'/>
   <button type='submit'>Submit</button>
    </form>
    </div>
    </div>
  )
}

export default Login

